<mat-expansion-panel hideToggle expanded=true>
  <mat-expansion-panel-header #panelH (click)="panelH._toggle()">
    <mat-panel-title class="d-flex mr-0">
      En esta cuenta recibirás los abonos
      <button class="d-flex btn-editar-header align-items-center ml-auto" type="button" (click)="habilitarSeccionDatos()" *ngIf="puedeEditar">
        <img src="assets/icons/editar.png" alt="iconEdit">
      </button>
    </mat-panel-title>
  </mat-expansion-panel-header>
  <div>
    <div class="d-flex row-abonos justify-content-between align-items-center">
      <img class="logo-banco" [src]="imgBanco" *ngIf="mostrarBanco">
      <div *ngIf="mostrarBanco">
        <p class="txt-detalles">{{ dataPaso3.dataCuentaAbono.banco.relacion[0].descripcion }}</p>
        <ng-container *ngIf="!desplegarInfoempresa">
          <p class="txt-detalles"><b>Nº {{dataPaso3.dataCuentaAbono.numero}}</b>, a nombre de <b>{{ dataPaso3.dataCuentaAbono.nombre.nombres}} {{
            dataPaso3.dataCuentaAbono.nombre.apellidoPaterno }} {{ dataPaso3.dataCuentaAbono.nombre.apellidoMaterno }}</b></p>
        </ng-container>
        <ng-container *ngIf="desplegarInfoempresa">
          <p class="txt-detalles"><b>Nº {{dataPaso3.dataCuentaAbono.numero}}</b>, a nombre de <b>{{ dataPaso3.dataCuentaAbono.razonSocial }}</b></p>
        </ng-container>
      </div>
      <ng-container *ngIf="puedeEditar">
        <button id="edit-bco-mobile" class="d-flex btn-secondary-tbk btn-editar align-items-center ml-auto" type="button"
          value="Editar" (click)="habilitarSeccionDatos(); abrirModal();">
          <img src="assets/icons/editar.png" alt="">
          <p class="m-0">Editar</p>
        </button>
      </ng-container>
    </div>
    <div class="row-agenda-entrega" *ngIf="showEdCuenta">
        <form [formGroup]="formAbonos" novalidate>

            <div class="row">
                <div class="col-md-12 seleccion-flujo mt-36">
                  <!--   <mat-radio-group formControlName="tipoCuenta" (change)="verificarTipoCuenta()">
                        <mat-radio-button value="PROPIA" class="radio-cuenta-propia mr-63">Cuenta propia
                        </mat-radio-button>
                        <mat-radio-button value="TERCERO" class="radio-cuenta-terceros" [hidden]="esComercioInformal">Cuenta de terceros
                        </mat-radio-button>
                    </mat-radio-group> -->
                </div>
            </div>
            <app-messages *ngIf="true" class="informativo" [message]="mensaje"></app-messages>
            <div class="row ">
                <div class="col-md-6 mt-36">
                    <label for="rutTitular">RUT del titular de la cuenta</label>
                    <input [class.inputInvalido]="
                    formAbonos.get('rutTitular').invalid && formAbonos.get('rutTitular').touched
                  " formControlName="rutTitular"
                  (blur)="determineCuentachange();validarCaracteresNombreTitular()"
                  type="text" name="rutTitular" 
                  appFormatRut placeholder="Ej: 123456789" autocomplete="off" 
                  [readonly]="esComercioInformal"
                  [class.inputInvalido]="formAbonos.get('rutTitular').invalid && (formAbonos.get('rutTitular').touched || formAbonos.get('rutTitular').dirty)" />
                  <p
                  *ngIf="
                    (formAbonos.get('rutTitular').touched || formAbonos.get('rutTitular').dirty) &&
                    formAbonos.get('rutTitular').hasError('required')
                  "
                  class="mensajeError"
                >
                  {{ mensajeErrorCuentaBancaria.REQUIRED_RUTTITULAR_MESSAGE }}
                </p>
                <p
                  *ngIf="(formAbonos.get('rutTitular').touched || formAbonos.get('rutTitular').dirty) &&
                        formAbonos.get('rutTitular').hasError('dniInvalid')" class="mensajeError">
                  {{ mensajeErrorCuentaBancaria.INVALID_RUT_MESSAGE}}
                </p>        
                </div>
                <div class="col-md-6 mt-36">
                  <ng-container *ngIf="!isEmpresa; else empresa">
                    <label for="nombresTitular">Nombres</label>
                    <input 
                    appCaracteres 
                    formControlName="nombres" 
                    type="text" 
                    name="nombresTitular" 
                    placeholder="Nombres"
                    autocomplete="off"
                    [appMaxLength]="18"
                    [appCaractereslimit]="'mensajeErrorNombre'"
                    [readonly]="bloquearInputs || esComercioInformal"
                    [class.inputInvalido]="formAbonos.get('nombres').invalid && formAbonos.get('nombres').touched">
                    <p
                      *ngIf="(formAbonos.get('nombres').touched &&
                      formAbonos.get('nombres') === null) ||
                    (formAbonos.get('nombres').touched &&
                        formAbonos.get('nombres').invalid)" class="mensajeError">
                      {{ mensajeErrorCuentaBancaria.REQUIRED_NAME_MESSAGE}}  
                    </p>
                    <p
                      id="mensajeErrorNombre"
                      class="mensajeError"
                      style="display: none;"
                    >
                      Has alcanzado el límite máximo de caracteres (18).
                    </p>
                  </ng-container>
                  <ng-template #empresa>
                    <label for="nombresTitular">Razón social</label>
                    <input formControlName="nombres" 
                    type="text" name="nombresTitular" 
                    placeholder="Nombres" autocomplete="off" 
                    [appMaxLength]="50"
                    [appCaractereslimit]="'mensajeErrorRSocial'"
                    [readonly]="bloquearInputs || esComercioInformal"
                    [class.inputInvalido]="formAbonos.get('nombres').invalid && formAbonos.get('nombres').touched">
                    <p
                      *ngIf="(formAbonos.get('nombres').touched &&
                      formAbonos.get('nombres') === null) ||
                    (formAbonos.get('nombres').touched &&
                        formAbonos.get('nombres').invalid)" class="mensajeError">
                      {{ mensajeErrorCuentaBancaria.REQUIRED_RAZONSOCIAL_MESSAGE}}  
                    </p>
                    <p
                    id="mensajeErrorRSocial"
                    class="mensajeError"
                    style="display: none;"
                  >
                    Has alcanzado el límite máximo de caracteres (50).
                  </p>
                  </ng-template>
                </div>
            </div>
            <div class="row ">
              <ng-container *ngIf="!isEmpresa">
                <div class="col-md-6 mt-36">
                    <label for="primerApellido">Primer Apellido</label>
                    <input 
                      appCaracteres 
                      formControlName="primerApellido" 
                      type="text" name="primerApellido" 
                      placeholder="Primer Apellido" 
                      autocomplete="off" 
                      [appMaxLength]="15"
                      [appCaractereslimit]="'mensajeErrorSp'" 
                      [readonly]="bloquearInputs || esComercioInformal"
                      [class.inputInvalido]="formAbonos.get('primerApellido').invalid && formAbonos.get('primerApellido').touched" required
                    />
                    <p
                      *ngIf="
                        (formAbonos.get('primerApellido').touched &&
                          formAbonos.get('primerApellido') === null) ||
                        (formAbonos.get('primerApellido').touched &&
                          formAbonos.get('primerApellido').invalid)
                      "
                      class="mensajeError"
                    >
                      {{ mensajeErrorCuentaBancaria.REQUIRED_LASTNAME_MESSAGE }}
                    </p>
                    <p
                    id="mensajeErrorSp"
                    class="mensajeError"
                    style="display: none;"
                  >
                    Has alcanzado el límite máximo de caracteres (15).
                  </p>
                </div>
                <div class="col-md-6 mt-36">
                    <label for="segundoApellido">Segundo Apellido (Opcional)</label>
                    <input 
                      appCaracteres
                      formControlName="segundoApellido" 
                      type="text" 
                      name="segundoApellido" 
                      placeholder="Segundo Apellido" 
                      autocomplete="off" 
                      [appMaxLength]="15"
                      [appCaractereslimit]="'mensajeErrorSa'"
                      [readonly]="bloquearInputs || esComercioInformal">
                      <p
                          id="mensajeErrorSa"
                          class="mensajeError"
                          style="display: none;"
                        >
                          Has alcanzado el límite máximo de caracteres (15).
                        </p>
                </div>
              </ng-container>
            </div>
            <div class="row">
                <div class="col-md-6 mt-36">
                    <label for="bancos">Selecciona banco</label>
                    <select 
                      formControlName="banco" 
                      name="bancos" 
                      (change)="cambioBanco()"
                      [class.selectInvalido]="formAbonos.get('banco').invalid && formAbonos.get('banco').touched"
                      >
                        <option value="">Seleccione</option>
                        <option *ngFor="let banco of datosBanco" [value]="banco.id">{{ banco.asString }}</option>
                      </select>
                      <p
                        *ngIf="(formAbonos.get('banco').touched && formAbonos.get('banco') === null) ||
                        (formAbonos.get('banco').touched && formAbonos.get('banco').invalid)" class="mensajeError">
                        {{ mensajeErrorCuentaBancaria.REQUIRED_BANK_MESSAGE}}
                      </p>
                </div>
                <div class="col-md-6 mt-36">
                    <label for="tipoCuenta">Selecciona tipo de cuenta</label>
                    <select name="tipoCuenta" formControlName="tipoCuentaBanco" (change)="isCuentaRut()"
                      [class.selectInvalido]="formAbonos.get('tipoCuentaBanco').invalid && formAbonos.get('tipoCuentaBanco').touched">
                        <option value="">Seleccione</option>
                        <option *ngFor="let tipoCuenta of dataTipoCuenta" [value]="tipoCuenta.id">{{ tipoCuenta.descripcion }}</option>
                      </select>
                      <p *ngIf="(formAbonos.get('tipoCuentaBanco').touched && formAbonos.get('tipoCuentaBanco') === null) ||
                                (formAbonos.get('tipoCuentaBanco').touched && formAbonos.get('tipoCuentaBanco').invalid)" class="mensajeError">
                          {{mensajeErrorCuentaBancaria.REQUIRED_COUNTTIPE_MESSAGE}}
                      </p>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6 mt-36">
                    <label for="numeroCuenta">Ingresa número de cuenta</label>
                    <input appNumeros formControlName="numeroCuenta" type="text" name="numeroCuenta"
                     placeholder="Nro. Cuenta" autocomplete="off" appMaxLength="18" [readonly]="disableNumeroCuenta"
                    [class.inputInvalido]="formAbonos.get('numeroCuenta').invalid && formAbonos.get('numeroCuenta').touched"   required />
                    <p *ngIf="(formAbonos.get('numeroCuenta').touched && formAbonos.get('numeroCuenta') === null) ||
                              (formAbonos.get('numeroCuenta').touched && formAbonos.get('numeroCuenta').invalid)" class="mensajeError">
                      {{mensajeErrorCuentaBancaria.REQUIRED_COUNTNUMBER_MESSAGE}}
                    </p>
                </div>
            </div>

            <div class="row">
                <div class="col-md-12 terminos-condiciones mt-36">
                    <mat-checkbox formControlName="verificado" tabindex="4" (change)="verCheck()">He verificado que el número de cuenta es correcto
                    </mat-checkbox>
                </div>
            </div>
            <div class="d-flex">
              <div class="col-md-6 mt-36">
                  <button class="btn-secondary-tbk mt-5" type="button" value="Cancelar" (click)="habilitarSeccionDatos()">Cancelar</button>
              </div>
              <div class="col-md-6 mt-36">
                  <button 
                    class="btn-primary-tbk float-right" 
                    value="Guardar" 
                    [disabled]="formAbonos.status === 'INVALID'" 
                    (click)="guardarCuentaAbono()"
                  >
                    <div *ngIf="loading" class="spinner-border text-light" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                    <div class="mt-5" *ngIf="!loading" >Guardar</div>            
                  </button>
              </div>
            </div>
        </form>
    </div>
  </div>
</mat-expansion-panel>


  <!-- Modal de información para pegar datos bancarios -->


  <div class="modal fade" id="clipboardModal" tabindex="-1" role="dialog" aria-labelledby="clipboardModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <svg width="22" height="28" viewBox="0 0 22 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.66671 15.3332C5.66671 14.5968 6.26366 13.9998 7.00004 13.9998H11C11.7364 13.9998 12.3334 14.5968 12.3334 15.3332C12.3334 16.0696 11.7364 16.6665 11 16.6665H7.00004C6.26366 16.6665 5.66671 16.0696 5.66671 15.3332Z" fill="#3B3CF7"/>
            <path d="M7.00004 19.3332C6.26366 19.3332 5.66671 19.9301 5.66671 20.6665C5.66671 21.4029 6.26366 21.9998 7.00004 21.9998H15C15.7364 21.9998 16.3334 21.4029 16.3334 20.6665C16.3334 19.9301 15.7364 19.3332 15 19.3332H7.00004Z" fill="#3B3CF7"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M14.0667 1.10674L21.32 9.10674C21.5423 9.35127 21.6658 9.66963 21.6667 10.0001V24.0001C21.6615 24.4431 21.5691 24.8807 21.3947 25.288C21.2203 25.6953 20.9674 26.0642 20.6505 26.3737C20.3335 26.6833 19.9587 26.9273 19.5474 27.092C19.1361 27.2567 18.6964 27.3387 18.2534 27.3334H3.74671C3.30371 27.3387 2.864 27.2567 2.45271 27.092C2.04141 26.9273 1.66658 26.6833 1.34962 26.3737C1.03265 26.0642 0.779766 25.6953 0.605398 25.288C0.43103 24.8807 0.338596 24.4431 0.333374 24.0001V4.00008C0.338596 3.55708 0.43103 3.11944 0.605398 2.71217C0.779766 2.30489 1.03265 1.93595 1.34962 1.62642C1.66658 1.31688 2.04141 1.07281 2.45271 0.908152C2.864 0.743491 3.30371 0.66146 3.74671 0.666744H13.08C13.2661 0.667184 13.45 0.706559 13.6199 0.782338C13.7899 0.858116 13.942 0.96862 14.0667 1.10674ZM17.32 8.66674L13.6667 4.66674V7.53341C13.6558 7.67287 13.6728 7.8131 13.7167 7.94591C13.7606 8.07872 13.8306 8.20146 13.9224 8.30696C14.0142 8.41246 14.1262 8.49861 14.2517 8.56039C14.3772 8.62216 14.5137 8.65831 14.6534 8.66674H17.32ZM3.74671 24.6667H18.2534C18.3462 24.6721 18.4392 24.6592 18.527 24.6286C18.6148 24.598 18.6957 24.5503 18.7651 24.4884C18.8345 24.4265 18.8909 24.3515 18.9312 24.2677C18.9715 24.1839 18.9949 24.0929 19 24.0001V11.3334H14.6134C13.6314 11.3055 12.7003 10.8902 12.0233 10.1783C11.3464 9.46638 10.9785 8.51557 11 7.53341V3.33341H3.74671C3.65387 3.32801 3.56088 3.34098 3.47307 3.37158C3.38526 3.40219 3.30436 3.44982 3.23499 3.51175C3.16562 3.57369 3.10916 3.6487 3.06885 3.7325C3.02853 3.8163 3.00515 3.90723 3.00004 4.00008V24.0001C3.00515 24.0929 3.02853 24.1839 3.06885 24.2677C3.10916 24.3515 3.16562 24.4265 3.23499 24.4884C3.30436 24.5503 3.38526 24.598 3.47307 24.6286C3.56088 24.6592 3.65387 24.6721 3.74671 24.6667Z" fill="#3B3CF7"/>
            </svg>
          <p class="modal-title" id="clipboardModalLabel">
            <br /><br />
              Copia y pega tu datos bancarios
          </p>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="cerrarModal()">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <h3 class="text-left"><strong>Activa y usa los datos desde el portapapeles</strong> </h3>
          <p class="text-left">
            Para activar la función <strong> pegar datos bancarios </strong>, presiona el botón <strong>Permitir</strong> que aparece arriba en tu navegador.<br />
          </p>
          <p><img src="assets/images/modal/permitepegar.png" alt="Instrucciones para copiar y pegar" style="max-width:100%; height:auto;"/></p>
          
          <button class="btn-primary-tbk ent-max mx-auto" (click)="cerrarModal()">Entendido</button>

        </div>
      </div>
    </div>
  </div>